import BaseModule from 'sdk/base/base-module';
import { ActionTypes, sliceName } from './loginConfig';
import FirebaseApi from '../firebase';
import { BASE_ACTION_TYPES } from 'sdk/base/store/reducer.consts';
import { Store } from '@reduxjs/toolkit';
import UserApi from '../user';
import { User } from 'firebase/auth';

export default class LoginApi extends BaseModule {
    public static instance: LoginApi;
    private firebaseApi: FirebaseApi = FirebaseApi.getInstance();
    constructor(store: Store) {
        if (LoginApi.instance) {
            return LoginApi.instance;
        }
        super(store, ActionTypes, sliceName);
        this.firebaseApi = FirebaseApi.getInstance();
        this.firebaseApi.auth?.onAuthStateChanged((user: User | null) => {
            this.dispatchAction(ActionTypes.UPDATE_USER_IN_CONTEXT, user);
        });
        LoginApi.instance = this;
    }

    public static getInstance = () => {
        return LoginApi.instance;
    };
	
    login = async (user: User) => {
        try {
            window.localStorage.setItem('USER', user.uid);
            await UserApi.getInstance().initUser(user);
        } catch (err) {
            this.dispatchAction(ActionTypes.UPDATE_LOGIN_ERROR, err);
        }
    };

    getFBCurrentUser = () => {
        const info = this.firebaseApi.getAuthRef()?.currentUser;
        return info;
    };
    

    deleteUserFromCookies = () => {
        document.cookie = 'USER=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    };

    saveUserToCookies = (uid: string) => {
        const date = new Date();
        date.setTime(date.getTime() + 10 * 24 * 60 * 60 * 1000);
        document.cookie = `USER=${uid}; expires=${date.toUTCString()}; path=/`;
    };

    getUserIdFromCookies = () => {
        const name = 'USER=';
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        return ca.find((c) => c.includes(name))?.replace(name, '');
    };
    
    getUser = () => {
        return window.localStorage.getItem('USER');
    };

    logout = async () => {
        await this.firebaseApi.getAuthRef()?.signOut();
        this.deleteUserFromCookies();
        window.localStorage.removeItem('USER');
        this.dispatchAction(BASE_ACTION_TYPES.CLEAR_STORE);
        UserApi.getInstance().clearCurrentUser();
    };


    isLoggedIn = () => {
        return !!this.getUser();
    };

}
